// Autogenerated by script
import type { SvgIconProps } from '@mui/material';
import dynamic from 'next/dynamic';

export const Accessibility = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Accessibility/Accessibility').then((mod) => mod.Accessibility),
  {
    ssr: true,
  }
);

export const Add = dynamic<SvgIconProps>(() => import('@portals/icons/src/Add/Add').then((mod) => mod.Add), {
  ssr: true,
});

export const AddCircleOutline = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/AddCircleOutline/AddCircleOutline').then((mod) => mod.AddCircleOutline),
  {
    ssr: true,
  }
);

export const Airplane = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Airplane/Airplane').then((mod) => mod.Airplane),
  {
    ssr: true,
  }
);

export const AlarmClock = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/AlarmClock/AlarmClock').then((mod) => mod.AlarmClock),
  {
    ssr: true,
  }
);

export const Alert = dynamic<SvgIconProps>(() => import('@portals/icons/src/Alert/Alert').then((mod) => mod.Alert), {
  ssr: true,
});

export const AlertCircleInvert = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/AlertCircleInvert/AlertCircleInvert').then((mod) => mod.AlertCircleInvert),
  {
    ssr: true,
  }
);

export const AlertCircleOutline = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/AlertCircleOutline/AlertCircleOutline').then((mod) => mod.AlertCircleOutline),
  {
    ssr: true,
  }
);

export const AlertTriangleInverted = dynamic<SvgIconProps>(
  () =>
    import('@portals/icons/src/AlertTriangleInverted/AlertTriangleInverted').then((mod) => mod.AlertTriangleInverted),
  {
    ssr: true,
  }
);

export const AllDirections = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/AllDirections/AllDirections').then((mod) => mod.AllDirections),
  {
    ssr: true,
  }
);

export const AmazonMusic = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/AmazonMusic/AmazonMusic').then((mod) => mod.AmazonMusic),
  {
    ssr: true,
  }
);

export const AppleMusic = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/AppleMusic/AppleMusic').then((mod) => mod.AppleMusic),
  {
    ssr: true,
  }
);

export const Area = dynamic<SvgIconProps>(() => import('@portals/icons/src/Area/Area').then((mod) => mod.Area), {
  ssr: true,
});

export const ArrowLeft = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ArrowLeft/ArrowLeft').then((mod) => mod.ArrowLeft),
  {
    ssr: true,
  }
);

export const ArrowLeftRight = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ArrowLeftRight/ArrowLeftRight').then((mod) => mod.ArrowLeftRight),
  {
    ssr: true,
  }
);

export const ArrowLeftSmall = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ArrowLeftSmall/ArrowLeftSmall').then((mod) => mod.ArrowLeftSmall),
  {
    ssr: true,
  }
);

export const ArrowRight = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ArrowRight/ArrowRight').then((mod) => mod.ArrowRight),
  {
    ssr: true,
  }
);

export const ArrowRightSmall = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ArrowRightSmall/ArrowRightSmall').then((mod) => mod.ArrowRightSmall),
  {
    ssr: true,
  }
);

export const Art = dynamic<SvgIconProps>(() => import('@portals/icons/src/Art/Art').then((mod) => mod.Art), {
  ssr: true,
});

export const Audio = dynamic<SvgIconProps>(() => import('@portals/icons/src/Audio/Audio').then((mod) => mod.Audio), {
  ssr: true,
});

export const Ball = dynamic<SvgIconProps>(() => import('@portals/icons/src/Ball/Ball').then((mod) => mod.Ball), {
  ssr: true,
});

export const BankNote = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/BankNote/BankNote').then((mod) => mod.BankNote),
  {
    ssr: true,
  }
);

export const BankNotes = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/BankNotes/BankNotes').then((mod) => mod.BankNotes),
  {
    ssr: true,
  }
);

export const Bell = dynamic<SvgIconProps>(() => import('@portals/icons/src/Bell/Bell').then((mod) => mod.Bell), {
  ssr: true,
});

export const Bike = dynamic<SvgIconProps>(() => import('@portals/icons/src/Bike/Bike').then((mod) => mod.Bike), {
  ssr: true,
});

export const Blind = dynamic<SvgIconProps>(() => import('@portals/icons/src/Blind/Blind').then((mod) => mod.Blind), {
  ssr: true,
});

export const Boat = dynamic<SvgIconProps>(() => import('@portals/icons/src/Boat/Boat').then((mod) => mod.Boat), {
  ssr: true,
});

export const Book = dynamic<SvgIconProps>(() => import('@portals/icons/src/Book/Book').then((mod) => mod.Book), {
  ssr: true,
});

export const Bookmark = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Bookmark/Bookmark').then((mod) => mod.Bookmark),
  {
    ssr: true,
  }
);

export const BookmarkVariation = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/BookmarkVariation/BookmarkVariation').then((mod) => mod.BookmarkVariation),
  {
    ssr: true,
  }
);

export const Box = dynamic<SvgIconProps>(() => import('@portals/icons/src/Box/Box').then((mod) => mod.Box), {
  ssr: true,
});

export const Burger = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Burger/Burger').then((mod) => mod.Burger),
  {
    ssr: true,
  }
);

export const Bus = dynamic<SvgIconProps>(() => import('@portals/icons/src/Bus/Bus').then((mod) => mod.Bus), {
  ssr: true,
});

export const Calculator = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Calculator/Calculator').then((mod) => mod.Calculator),
  {
    ssr: true,
  }
);

export const Calendar = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Calendar/Calendar').then((mod) => mod.Calendar),
  {
    ssr: true,
  }
);

export const CalendarDays = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/CalendarDays/CalendarDays').then((mod) => mod.CalendarDays),
  {
    ssr: true,
  }
);

export const Camera = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Camera/Camera').then((mod) => mod.Camera),
  {
    ssr: true,
  }
);

export const Car = dynamic<SvgIconProps>(() => import('@portals/icons/src/Car/Car').then((mod) => mod.Car), {
  ssr: true,
});

export const Card = dynamic<SvgIconProps>(() => import('@portals/icons/src/Card/Card').then((mod) => mod.Card), {
  ssr: true,
});

export const CardBundle = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/CardBundle/CardBundle').then((mod) => mod.CardBundle),
  {
    ssr: true,
  }
);

export const CardMachine = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/CardMachine/CardMachine').then((mod) => mod.CardMachine),
  {
    ssr: true,
  }
);

export const Cars = dynamic<SvgIconProps>(() => import('@portals/icons/src/Cars/Cars').then((mod) => mod.Cars), {
  ssr: true,
});

export const ChartDiagram = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ChartDiagram/ChartDiagram').then((mod) => mod.ChartDiagram),
  {
    ssr: true,
  }
);

export const ChartEuro = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ChartEuro/ChartEuro').then((mod) => mod.ChartEuro),
  {
    ssr: true,
  }
);

export const Chat = dynamic<SvgIconProps>(() => import('@portals/icons/src/Chat/Chat').then((mod) => mod.Chat), {
  ssr: true,
});

export const Check = dynamic<SvgIconProps>(() => import('@portals/icons/src/Check/Check').then((mod) => mod.Check), {
  ssr: true,
});

export const CheckCircleInverted = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/CheckCircleInverted/CheckCircleInverted').then((mod) => mod.CheckCircleInverted),
  {
    ssr: true,
  }
);

export const CheckCircleOutline = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/CheckCircleOutline/CheckCircleOutline').then((mod) => mod.CheckCircleOutline),
  {
    ssr: true,
  }
);

export const CheckShieldOutline = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/CheckShieldOutline/CheckShieldOutline').then((mod) => mod.CheckShieldOutline),
  {
    ssr: true,
  }
);

export const Checked = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Checked/Checked').then((mod) => mod.Checked),
  {
    ssr: true,
  }
);

export const ChevronDown = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ChevronDown/ChevronDown').then((mod) => mod.ChevronDown),
  {
    ssr: true,
  }
);

export const ChevronDownSmall = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ChevronDownSmall/ChevronDownSmall').then((mod) => mod.ChevronDownSmall),
  {
    ssr: true,
  }
);

export const ChevronLeft = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ChevronLeft/ChevronLeft').then((mod) => mod.ChevronLeft),
  {
    ssr: true,
  }
);

export const ChevronLeftRight = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ChevronLeftRight/ChevronLeftRight').then((mod) => mod.ChevronLeftRight),
  {
    ssr: true,
  }
);

export const ChevronLeftSmall = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ChevronLeftSmall/ChevronLeftSmall').then((mod) => mod.ChevronLeftSmall),
  {
    ssr: true,
  }
);

export const ChevronRight = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ChevronRight/ChevronRight').then((mod) => mod.ChevronRight),
  {
    ssr: true,
  }
);

export const ChevronRightSmall = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ChevronRightSmall/ChevronRightSmall').then((mod) => mod.ChevronRightSmall),
  {
    ssr: true,
  }
);

export const ChevronUp = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ChevronUp/ChevronUp').then((mod) => mod.ChevronUp),
  {
    ssr: true,
  }
);

export const ChevronUpSmall = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ChevronUpSmall/ChevronUpSmall').then((mod) => mod.ChevronUpSmall),
  {
    ssr: true,
  }
);

export const CircleBack = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/CircleBack/CircleBack').then((mod) => mod.CircleBack),
  {
    ssr: true,
  }
);

export const Clock = dynamic<SvgIconProps>(() => import('@portals/icons/src/Clock/Clock').then((mod) => mod.Clock), {
  ssr: true,
});

export const Close = dynamic<SvgIconProps>(() => import('@portals/icons/src/Close/Close').then((mod) => mod.Close), {
  ssr: true,
});

export const CloseCircleOutline = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/CloseCircleOutline/CloseCircleOutline').then((mod) => mod.CloseCircleOutline),
  {
    ssr: true,
  }
);

export const CloseCircleInverted = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/CloseCircleInverted/CloseCircleInverted').then((mod) => mod.CloseCircleInverted),
  {
    ssr: true,
  }
);

export const Cloud = dynamic<SvgIconProps>(() => import('@portals/icons/src/Cloud/Cloud').then((mod) => mod.Cloud), {
  ssr: true,
});

export const CoffeeBreak = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/CoffeeBreak/CoffeeBreak').then((mod) => mod.CoffeeBreak),
  {
    ssr: true,
  }
);

export const CoinCrossed = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/CoinCrossed/CoinCrossed').then((mod) => mod.CoinCrossed),
  {
    ssr: true,
  }
);

export const Coins = dynamic<SvgIconProps>(() => import('@portals/icons/src/Coins/Coins').then((mod) => mod.Coins), {
  ssr: true,
});

export const Compass = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Compass/Compass').then((mod) => mod.Compass),
  {
    ssr: true,
  }
);

export const Connect = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Connect/Connect').then((mod) => mod.Connect),
  {
    ssr: true,
  }
);

export const Contract = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Contract/Contract').then((mod) => mod.Contract),
  {
    ssr: true,
  }
);

export const Contrast = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Contrast/Contrast').then((mod) => mod.Contrast),
  {
    ssr: true,
  }
);

export const Copy = dynamic<SvgIconProps>(() => import('@portals/icons/src/Copy/Copy').then((mod) => mod.Copy), {
  ssr: true,
});

export const Cursor = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Cursor/Cursor').then((mod) => mod.Cursor),
  {
    ssr: true,
  }
);

export const Cutlery = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Cutlery/Cutlery').then((mod) => mod.Cutlery),
  {
    ssr: true,
  }
);

export const Deaf = dynamic<SvgIconProps>(() => import('@portals/icons/src/Deaf/Deaf').then((mod) => mod.Deaf), {
  ssr: true,
});

export const Deka = dynamic<SvgIconProps>(() => import('@portals/icons/src/Deka/Deka').then((mod) => mod.Deka), {
  ssr: true,
});

export const Depot = dynamic<SvgIconProps>(() => import('@portals/icons/src/Depot/Depot').then((mod) => mod.Depot), {
  ssr: true,
});

export const Desktop = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Desktop/Desktop').then((mod) => mod.Desktop),
  {
    ssr: true,
  }
);

export const Directions = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Directions/Directions').then((mod) => mod.Directions),
  {
    ssr: true,
  }
);

export const DistrictHeatingHeatingPlant = dynamic<SvgIconProps>(
  () =>
    import('@portals/icons/src/DistrictHeatingHeatingPlant/DistrictHeatingHeatingPlant').then(
      (mod) => mod.DistrictHeatingHeatingPlant
    ),
  {
    ssr: true,
  }
);

export const Dot = dynamic<SvgIconProps>(() => import('@portals/icons/src/Dot/Dot').then((mod) => mod.Dot), {
  ssr: true,
});

export const DotsHorizontal = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/DotsHorizontal/DotsHorizontal').then((mod) => mod.DotsHorizontal),
  {
    ssr: true,
  }
);

export const DotsVertical = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/DotsVertical/DotsVertical').then((mod) => mod.DotsVertical),
  {
    ssr: true,
  }
);

export const DoubleCheck = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/DoubleCheck/DoubleCheck').then((mod) => mod.DoubleCheck),
  {
    ssr: true,
  }
);

export const Download = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Download/Download').then((mod) => mod.Download),
  {
    ssr: true,
  }
);

export const DownloadBox = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/DownloadBox/DownloadBox').then((mod) => mod.DownloadBox),
  {
    ssr: true,
  }
);

export const Duration = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Duration/Duration').then((mod) => mod.Duration),
  {
    ssr: true,
  }
);

export const EasyLanguage = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/EasyLanguage/EasyLanguage').then((mod) => mod.EasyLanguage),
  {
    ssr: true,
  }
);

export const Education = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Education/Education').then((mod) => mod.Education),
  {
    ssr: true,
  }
);

export const EmptyTrash = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/EmptyTrash/EmptyTrash').then((mod) => mod.EmptyTrash),
  {
    ssr: true,
  }
);

export const Euro = dynamic<SvgIconProps>(() => import('@portals/icons/src/Euro/Euro').then((mod) => mod.Euro), {
  ssr: true,
});

export const EuroWallet = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/EuroWallet/EuroWallet').then((mod) => mod.EuroWallet),
  {
    ssr: true,
  }
);

export const ExternalLink = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ExternalLink/ExternalLink').then((mod) => mod.ExternalLink),
  {
    ssr: true,
  }
);

export const Eye = dynamic<SvgIconProps>(() => import('@portals/icons/src/Eye/Eye').then((mod) => mod.Eye), {
  ssr: true,
});

export const Facebook = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Facebook/Facebook').then((mod) => mod.Facebook),
  {
    ssr: true,
  }
);

export const File = dynamic<SvgIconProps>(() => import('@portals/icons/src/File/File').then((mod) => mod.File), {
  ssr: true,
});

export const FileDiagram = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/FileDiagram/FileDiagram').then((mod) => mod.FileDiagram),
  {
    ssr: true,
  }
);

export const FileInfo = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/FileInfo/FileInfo').then((mod) => mod.FileInfo),
  {
    ssr: true,
  }
);

export const FilePlayButton = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/FilePlayButton/FilePlayButton').then((mod) => mod.FilePlayButton),
  {
    ssr: true,
  }
);

export const FileTable = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/FileTable/FileTable').then((mod) => mod.FileTable),
  {
    ssr: true,
  }
);

export const FileUndefined = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/FileUndefined/FileUndefined').then((mod) => mod.FileUndefined),
  {
    ssr: true,
  }
);

export const Filter = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Filter/Filter').then((mod) => mod.Filter),
  {
    ssr: true,
  }
);

export const FilterActivated = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/FilterActivated/FilterActivated').then((mod) => mod.FilterActivated),
  {
    ssr: true,
  }
);

export const Flag = dynamic<SvgIconProps>(() => import('@portals/icons/src/Flag/Flag').then((mod) => mod.Flag), {
  ssr: true,
});

export const FlatRoof = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/FlatRoof/FlatRoof').then((mod) => mod.FlatRoof),
  {
    ssr: true,
  }
);

export const Folder = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Folder/Folder').then((mod) => mod.Folder),
  {
    ssr: true,
  }
);

export const FolderAdd = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/FolderAdd/FolderAdd').then((mod) => mod.FolderAdd),
  {
    ssr: true,
  }
);

export const FreeStanding = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/FreeStanding/FreeStanding').then((mod) => mod.FreeStanding),
  {
    ssr: true,
  }
);

export const Frequency = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Frequency/Frequency').then((mod) => mod.Frequency),
  {
    ssr: true,
  }
);

export const Gass = dynamic<SvgIconProps>(() => import('@portals/icons/src/Gass/Gass').then((mod) => mod.Gass), {
  ssr: true,
});

export const GiropayPaycheck = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/GiropayPaycheck/GiropayPaycheck').then((mod) => mod.GiropayPaycheck),
  {
    ssr: true,
  }
);

export const Glasses = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Glasses/Glasses').then((mod) => mod.Glasses),
  {
    ssr: true,
  }
);

export const Globe = dynamic<SvgIconProps>(() => import('@portals/icons/src/Globe/Globe').then((mod) => mod.Globe), {
  ssr: true,
});

export const Gold = dynamic<SvgIconProps>(() => import('@portals/icons/src/Gold/Gold').then((mod) => mod.Gold), {
  ssr: true,
});

export const GooglePodcast = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/GooglePodcast/GooglePodcast').then((mod) => mod.GooglePodcast),
  {
    ssr: true,
  }
);

export const Growth = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Growth/Growth').then((mod) => mod.Growth),
  {
    ssr: true,
  }
);

export const Guitar = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Guitar/Guitar').then((mod) => mod.Guitar),
  {
    ssr: true,
  }
);

export const HandInHand = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/HandInHand/HandInHand').then((mod) => mod.HandInHand),
  {
    ssr: true,
  }
);

export const HandShake = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/HandShake/HandShake').then((mod) => mod.HandShake),
  {
    ssr: true,
  }
);

export const HeartInverted = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/HeartInverted/HeartInverted').then((mod) => mod.HeartInverted),
  {
    ssr: true,
  }
);

export const HeartLine = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/HeartLine/HeartLine').then((mod) => mod.HeartLine),
  {
    ssr: true,
  }
);

export const HeartOutlined = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/HeartOutlined/HeartOutlined').then((mod) => mod.HeartOutlined),
  {
    ssr: true,
  }
);

export const Helmet = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Helmet/Helmet').then((mod) => mod.Helmet),
  {
    ssr: true,
  }
);

export const Hide = dynamic<SvgIconProps>(() => import('@portals/icons/src/Hide/Hide').then((mod) => mod.Hide), {
  ssr: true,
});

export const Home = dynamic<SvgIconProps>(() => import('@portals/icons/src/Home/Home').then((mod) => mod.Home), {
  ssr: true,
});

export const HomeInverted = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/HomeInverted/HomeInverted').then((mod) => mod.HomeInverted),
  {
    ssr: true,
  }
);

export const HourGlass = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/HourGlass/HourGlass').then((mod) => mod.HourGlass),
  {
    ssr: true,
  }
);

export const HourGlassUp = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/HourGlassUp/HourGlassUp').then((mod) => mod.HourGlassUp),
  {
    ssr: true,
  }
);

export const IdCard = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/IdCard/IdCard').then((mod) => mod.IdCard),
  {
    ssr: true,
  }
);

export const ImpulsLogo = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ImpulsLogo/ImpulsLogo').then((mod) => mod.ImpulsLogo),
  {
    ssr: true,
  }
);

export const Industry = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Industry/Industry').then((mod) => mod.Industry),
  {
    ssr: true,
  }
);

export const InfoCircleInvert = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/InfoCircleInvert/InfoCircleInvert').then((mod) => mod.InfoCircleInvert),
  {
    ssr: true,
  }
);

export const InfoCircleOutline = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/InfoCircleOutline/InfoCircleOutline').then((mod) => mod.InfoCircleOutline),
  {
    ssr: true,
  }
);

export const Instagram = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Instagram/Instagram').then((mod) => mod.Instagram),
  {
    ssr: true,
  }
);

export const Key = dynamic<SvgIconProps>(() => import('@portals/icons/src/Key/Key').then((mod) => mod.Key), {
  ssr: true,
});

export const Laptop = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Laptop/Laptop').then((mod) => mod.Laptop),
  {
    ssr: true,
  }
);

export const Letter = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Letter/Letter').then((mod) => mod.Letter),
  {
    ssr: true,
  }
);

export const Like = dynamic<SvgIconProps>(() => import('@portals/icons/src/Like/Like').then((mod) => mod.Like), {
  ssr: true,
});

export const LineHeight = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/LineHeight/LineHeight').then((mod) => mod.LineHeight),
  {
    ssr: true,
  }
);

export const LinkedIn = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/LinkedIn/LinkedIn').then((mod) => mod.LinkedIn),
  {
    ssr: true,
  }
);

export const Living = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Living/Living').then((mod) => mod.Living),
  {
    ssr: true,
  }
);

export const Location = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Location/Location').then((mod) => mod.Location),
  {
    ssr: true,
  }
);

export const LocationPins = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/LocationPins/LocationPins').then((mod) => mod.LocationPins),
  {
    ssr: true,
  }
);

export const Lock = dynamic<SvgIconProps>(() => import('@portals/icons/src/Lock/Lock').then((mod) => mod.Lock), {
  ssr: true,
});

export const LockEuro = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/LockEuro/LockEuro').then((mod) => mod.LockEuro),
  {
    ssr: true,
  }
);

export const LockNegative = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/LockNegative/LockNegative').then((mod) => mod.LockNegative),
  {
    ssr: true,
  }
);

export const Mail = dynamic<SvgIconProps>(() => import('@portals/icons/src/Mail/Mail').then((mod) => mod.Mail), {
  ssr: true,
});

export const Mask = dynamic<SvgIconProps>(() => import('@portals/icons/src/Mask/Mask').then((mod) => mod.Mask), {
  ssr: true,
});

export const Minus = dynamic<SvgIconProps>(() => import('@portals/icons/src/Minus/Minus').then((mod) => mod.Minus), {
  ssr: true,
});

export const Mobile = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Mobile/Mobile').then((mod) => mod.Mobile),
  {
    ssr: true,
  }
);

export const MobilePay = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/MobilePay/MobilePay').then((mod) => mod.MobilePay),
  {
    ssr: true,
  }
);

export const Mobility = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Mobility/Mobility').then((mod) => mod.Mobility),
  {
    ssr: true,
  }
);

export const MoneyHand = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/MoneyHand/MoneyHand').then((mod) => mod.MoneyHand),
  {
    ssr: true,
  }
);

export const NaturalGas = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/NaturalGas/NaturalGas').then((mod) => mod.NaturalGas),
  {
    ssr: true,
  }
);

export const Note = dynamic<SvgIconProps>(() => import('@portals/icons/src/Note/Note').then((mod) => mod.Note), {
  ssr: true,
});

export const OilFuel = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/OilFuel/OilFuel').then((mod) => mod.OilFuel),
  {
    ssr: true,
  }
);

export const Options = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Options/Options').then((mod) => mod.Options),
  {
    ssr: true,
  }
);

export const OvenWoodChips = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/OvenWoodChips/OvenWoodChips').then((mod) => mod.OvenWoodChips),
  {
    ssr: true,
  }
);

export const OvenWoodPellets = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/OvenWoodPellets/OvenWoodPellets').then((mod) => mod.OvenWoodPellets),
  {
    ssr: true,
  }
);

export const PalmTree = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/PalmTree/PalmTree').then((mod) => mod.PalmTree),
  {
    ssr: true,
  }
);

export const PaperAirplane = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/PaperAirplane/PaperAirplane').then((mod) => mod.PaperAirplane),
  {
    ssr: true,
  }
);

export const PaperClip = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/PaperClip/PaperClip').then((mod) => mod.PaperClip),
  {
    ssr: true,
  }
);

export const Paragraph = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Paragraph/Paragraph').then((mod) => mod.Paragraph),
  {
    ssr: true,
  }
);

export const ParkingSpace = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ParkingSpace/ParkingSpace').then((mod) => mod.ParkingSpace),
  {
    ssr: true,
  }
);

export const Partner = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Partner/Partner').then((mod) => mod.Partner),
  {
    ssr: true,
  }
);

export const Pause = dynamic<SvgIconProps>(() => import('@portals/icons/src/Pause/Pause').then((mod) => mod.Pause), {
  ssr: true,
});

export const PayDirekt = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/PayDirekt/PayDirekt').then((mod) => mod.PayDirekt),
  {
    ssr: true,
  }
);

export const Paypal = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Paypal/Paypal').then((mod) => mod.Paypal),
  {
    ssr: true,
  }
);

export const PitchedRoof = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/PitchedRoof/PitchedRoof').then((mod) => mod.PitchedRoof),
  {
    ssr: true,
  }
);

export const Pdf = dynamic<SvgIconProps>(() => import('@portals/icons/src/Pdf/Pdf').then((mod) => mod.Pdf), {
  ssr: true,
});

export const Pen = dynamic<SvgIconProps>(() => import('@portals/icons/src/Pen/Pen').then((mod) => mod.Pen), {
  ssr: true,
});

export const PercentCircleOutline = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/PercentCircleOutline/PercentCircleOutline').then((mod) => mod.PercentCircleOutline),
  {
    ssr: true,
  }
);

export const Percentage = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Percentage/Percentage').then((mod) => mod.Percentage),
  {
    ssr: true,
  }
);

export const PersonFemale = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/PersonFemale/PersonFemale').then((mod) => mod.PersonFemale),
  {
    ssr: true,
  }
);

export const PersonMale = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/PersonMale/PersonMale').then((mod) => mod.PersonMale),
  {
    ssr: true,
  }
);

export const PersonPlus = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/PersonPlus/PersonPlus').then((mod) => mod.PersonPlus),
  {
    ssr: true,
  }
);

export const Pet = dynamic<SvgIconProps>(() => import('@portals/icons/src/Pet/Pet').then((mod) => mod.Pet), {
  ssr: true,
});

export const PiggyLeft = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/PiggyLeft/PiggyLeft').then((mod) => mod.PiggyLeft),
  {
    ssr: true,
  }
);

export const PiggyRight = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/PiggyRight/PiggyRight').then((mod) => mod.PiggyRight),
  {
    ssr: true,
  }
);

export const Pin = dynamic<SvgIconProps>(() => import('@portals/icons/src/Pin/Pin').then((mod) => mod.Pin), {
  ssr: true,
});

export const PinCode = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/PinCode/PinCode').then((mod) => mod.PinCode),
  {
    ssr: true,
  }
);

export const PlayButton = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/PlayButton/PlayButton').then((mod) => mod.PlayButton),
  {
    ssr: true,
  }
);

export const PlusMinus = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/PlusMinus/PlusMinus').then((mod) => mod.PlusMinus),
  {
    ssr: true,
  }
);

export const PointedRoof = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/PointedRoof/PointedRoof').then((mod) => mod.PointedRoof),
  {
    ssr: true,
  }
);

export const Puzzle = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Puzzle/Puzzle').then((mod) => mod.Puzzle),
  {
    ssr: true,
  }
);

export const Pyramid = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Pyramid/Pyramid').then((mod) => mod.Pyramid),
  {
    ssr: true,
  }
);

export const QuestionCircleInvert = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/QuestionCircleInvert/QuestionCircleInvert').then((mod) => mod.QuestionCircleInvert),
  {
    ssr: true,
  }
);

export const QuestionCircleOutline = dynamic<SvgIconProps>(
  () =>
    import('@portals/icons/src/QuestionCircleOutline/QuestionCircleOutline').then((mod) => mod.QuestionCircleOutline),
  {
    ssr: true,
  }
);

export const Reload = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Reload/Reload').then((mod) => mod.Reload),
  {
    ssr: true,
  }
);

export const ReloadLeft = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ReloadLeft/ReloadLeft').then((mod) => mod.ReloadLeft),
  {
    ssr: true,
  }
);

export const ReloadRight = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ReloadRight/ReloadRight').then((mod) => mod.ReloadRight),
  {
    ssr: true,
  }
);

export const RemoveCircleOutline = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/RemoveCircleOutline/RemoveCircleOutline').then((mod) => mod.RemoveCircleOutline),
  {
    ssr: true,
  }
);

export const RollerBlades = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/RollerBlades/RollerBlades').then((mod) => mod.RollerBlades),
  {
    ssr: true,
  }
);

export const Rooms = dynamic<SvgIconProps>(() => import('@portals/icons/src/Rooms/Rooms').then((mod) => mod.Rooms), {
  ssr: true,
});

export const RowCenter = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/RowCenter/RowCenter').then((mod) => mod.RowCenter),
  {
    ssr: true,
  }
);

export const RudiLogo = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/RudiLogo/RudiLogo').then((mod) => mod.RudiLogo),
  {
    ssr: true,
  }
);

export const RoundedCoins = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/RoundedCoins/RoundedCoins').then((mod) => mod.RoundedCoins),
  {
    ssr: true,
  }
);

export const SackBarrow = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/SackBarrow/SackBarrow').then((mod) => mod.SackBarrow),
  {
    ssr: true,
  }
);

export const Search = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Search/Search').then((mod) => mod.Search),
  {
    ssr: true,
  }
);

export const SearchReflection = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/SearchReflection/SearchReflection').then((mod) => mod.SearchReflection),
  {
    ssr: true,
  }
);

export const SemiDetached = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/SemiDetached/SemiDetached').then((mod) => mod.SemiDetached),
  {
    ssr: true,
  }
);

export const SendEuro = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/SendEuro/SendEuro').then((mod) => mod.SendEuro),
  {
    ssr: true,
  }
);

export const Setting = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Setting/Setting').then((mod) => mod.Setting),
  {
    ssr: true,
  }
);

export const Settings = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Settings/Settings').then((mod) => mod.Settings),
  {
    ssr: true,
  }
);

export const ShareSocialMedia = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ShareSocialMedia/ShareSocialMedia').then((mod) => mod.ShareSocialMedia),
  {
    ssr: true,
  }
);

export const ShieldOutline = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/ShieldOutline/ShieldOutline').then((mod) => mod.ShieldOutline),
  {
    ssr: true,
  }
);

export const SparkasseLogo = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/SparkasseLogo/SparkasseLogo').then((mod) => mod.SparkasseLogo),
  {
    ssr: true,
  }
);

export const Speaker = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Speaker/Speaker').then((mod) => mod.Speaker),
  {
    ssr: true,
  }
);

export const SpeechBubbleInverted = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/SpeechBubbleInverted/SpeechBubbleInverted').then((mod) => mod.SpeechBubbleInverted),
  {
    ssr: true,
  }
);

export const SpeechBubbles = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/SpeechBubbles/SpeechBubbles').then((mod) => mod.SpeechBubbles),
  {
    ssr: true,
  }
);

export const Speedo = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Speedo/Speedo').then((mod) => mod.Speedo),
  {
    ssr: true,
  }
);

export const Spotify = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Spotify/Spotify').then((mod) => mod.Spotify),
  {
    ssr: true,
  }
);

export const Star = dynamic<SvgIconProps>(() => import('@portals/icons/src/Star/Star').then((mod) => mod.Star), {
  ssr: true,
});

export const Stitcher = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Stitcher/Stitcher').then((mod) => mod.Stitcher),
  {
    ssr: true,
  }
);

export const Stop = dynamic<SvgIconProps>(() => import('@portals/icons/src/Stop/Stop').then((mod) => mod.Stop), {
  ssr: true,
});

export const Storey_1 = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Storey_1/Storey_1').then((mod) => mod.Storey_1),
  {
    ssr: true,
  }
);

export const Storey_2 = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Storey_2/Storey_2').then((mod) => mod.Storey_2),
  {
    ssr: true,
  }
);

export const Storey_3 = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Storey_3/Storey_3').then((mod) => mod.Storey_3),
  {
    ssr: true,
  }
);

export const Suitcase = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Suitcase/Suitcase').then((mod) => mod.Suitcase),
  {
    ssr: true,
  }
);

export const Sun = dynamic<SvgIconProps>(() => import('@portals/icons/src/Sun/Sun').then((mod) => mod.Sun), {
  ssr: true,
});

export const TShirt = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/TShirt/TShirt').then((mod) => mod.TShirt),
  {
    ssr: true,
  }
);

export const Tablet = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Tablet/Tablet').then((mod) => mod.Tablet),
  {
    ssr: true,
  }
);

export const Target = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Target/Target').then((mod) => mod.Target),
  {
    ssr: true,
  }
);

export const Telephone = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Telephone/Telephone').then((mod) => mod.Telephone),
  {
    ssr: true,
  }
);

export const TelephoneCircleOutline = dynamic<SvgIconProps>(
  () =>
    import('@portals/icons/src/TelephoneCircleOutline/TelephoneCircleOutline').then(
      (mod) => mod.TelephoneCircleOutline
    ),
  {
    ssr: true,
  }
);

export const TextAlignment = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/TextAlignment/TextAlignment').then((mod) => mod.TextAlignment),
  {
    ssr: true,
  }
);

export const TextSize = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/TextSize/TextSize').then((mod) => mod.TextSize),
  {
    ssr: true,
  }
);

export const ThermalHeatPumpAirWater = dynamic<SvgIconProps>(
  () =>
    import('@portals/icons/src/ThermalHeatPumpAirWater/ThermalHeatPumpAirWater').then(
      (mod) => mod.ThermalHeatPumpAirWater
    ),
  {
    ssr: true,
  }
);

export const Tiktok = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Tiktok/Tiktok').then((mod) => mod.Tiktok),
  {
    ssr: true,
  }
);

export const Trash = dynamic<SvgIconProps>(() => import('@portals/icons/src/Trash/Trash').then((mod) => mod.Trash), {
  ssr: true,
});

export const Travel = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Travel/Travel').then((mod) => mod.Travel),
  {
    ssr: true,
  }
);

export const Tree = dynamic<SvgIconProps>(() => import('@portals/icons/src/Tree/Tree').then((mod) => mod.Tree), {
  ssr: true,
});

export const Truck = dynamic<SvgIconProps>(() => import('@portals/icons/src/Truck/Truck').then((mod) => mod.Truck), {
  ssr: true,
});

export const TuneIn = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/TuneIn/TuneIn').then((mod) => mod.TuneIn),
  {
    ssr: true,
  }
);

export const TurnOff = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/TurnOff/TurnOff').then((mod) => mod.TurnOff),
  {
    ssr: true,
  }
);

export const Twitter = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Twitter/Twitter').then((mod) => mod.Twitter),
  {
    ssr: true,
  }
);

export const Umbrella = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Umbrella/Umbrella').then((mod) => mod.Umbrella),
  {
    ssr: true,
  }
);

export const Unequal = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Unequal/Unequal').then((mod) => mod.Unequal),
  {
    ssr: true,
  }
);

export const Unlocked = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Unlocked/Unlocked').then((mod) => mod.Unlocked),
  {
    ssr: true,
  }
);

export const UnreadMailInverted = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/UnreadMailInverted/UnreadMailInverted').then((mod) => mod.UnreadMailInverted),
  {
    ssr: true,
  }
);

export const Upload = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Upload/Upload').then((mod) => mod.Upload),
  {
    ssr: true,
  }
);

export const UploadBox = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/UploadBox/UploadBox').then((mod) => mod.UploadBox),
  {
    ssr: true,
  }
);

export const Volume = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Volume/Volume').then((mod) => mod.Volume),
  {
    ssr: true,
  }
);

export const Wallet = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Wallet/Wallet').then((mod) => mod.Wallet),
  {
    ssr: true,
  }
);

export const Watch = dynamic<SvgIconProps>(() => import('@portals/icons/src/Watch/Watch').then((mod) => mod.Watch), {
  ssr: true,
});

export const WhatsApp = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/WhatsApp/WhatsApp').then((mod) => mod.WhatsApp),
  {
    ssr: true,
  }
);

export const Wheelchair = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Wheelchair/Wheelchair').then((mod) => mod.Wheelchair),
  {
    ssr: true,
  }
);

export const Wikipedia = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Wikipedia/Wikipedia').then((mod) => mod.Wikipedia),
  {
    ssr: true,
  }
);

export const X = dynamic<SvgIconProps>(() => import('@portals/icons/src/X/X').then((mod) => mod.X), {
  ssr: true,
});

export const Xing = dynamic<SvgIconProps>(() => import('@portals/icons/src/Xing/Xing').then((mod) => mod.Xing), {
  ssr: true,
});

export const Youtube = dynamic<SvgIconProps>(
  () => import('@portals/icons/src/Youtube/Youtube').then((mod) => mod.Youtube),
  {
    ssr: true,
  }
);

/**
 * Okay this File looks like a maintenance horror
 *
 * but this actually helps nextjs to
 *  - allow dynamic load icons
 *  - split chunk them
 *  - and still provide CSR/SSR
 *
 * faq:
 *  - Q: why do we have a switch case here?
 *  - A: we need to statically provide next the mapping, otherwise zou will get SSR/CSR errors
 *
 *  - Q: why do we load icons on SSR path
 *  - A: so we do not have a flickr effect, but we could also just render a 24x24 sceleton instead if we want
 *  - I: this would mean ssr: true -> ssr: false and placeholder must be something like <SvgIcon 24x24><rect /></SvgIcon>
 *
 * @param name
 */
export const loadIcon = (name: string) => {
  switch (name) {
    case 'DistrictHeatingHeatingPlant':
      return DistrictHeatingHeatingPlant;
    case 'FlatRoof':
      return FlatRoof;
    case 'FreeStanding':
      return FreeStanding;
    case 'NaturalGas':
      return NaturalGas;
    case 'OilFuel':
      return OilFuel;
    case 'OvenWoodChips':
      return OvenWoodChips;
    case 'OvenWoodPellets':
      return OvenWoodPellets;
    case 'PitchedRoof':
      return PitchedRoof;
    case 'PointedRoof':
      return PointedRoof;
    case 'RowCenter':
      return RowCenter;
    case 'SemiDetached':
      return SemiDetached;
    case 'Storey_1':
      return Storey_1;
    case 'Storey_2':
      return Storey_2;
    case 'Storey_3':
      return Storey_3;
    case 'ThermalHeatPumpAirWater':
      return ThermalHeatPumpAirWater;
    case 'Accessibility':
      return Accessibility;
    case 'Add':
      return Add;
    case 'AddCircleOutline':
      return AddCircleOutline;
    case 'Airplane':
      return Airplane;
    case 'AlarmClock':
      return AlarmClock;
    case 'Alert':
      return Alert;
    case 'AlertCircleInvert':
      return AlertCircleInvert;
    case 'AlertCircleOutline':
      return AlertCircleOutline;
    case 'AlertTriangleInverted':
      return AlertTriangleInverted;
    case 'AllDirections':
      return AllDirections;
    case 'AmazonMusic':
      return AmazonMusic;
    case 'AppleMusic':
      return AppleMusic;
    case 'Area':
      return Area;
    case 'ArrowLeft':
      return ArrowLeft;
    case 'ArrowLeftRight':
      return ArrowLeftRight;
    case 'ArrowLeftSmall':
      return ArrowLeftSmall;
    case 'ArrowRight':
      return ArrowRight;
    case 'ArrowRightSmall':
      return ArrowRightSmall;
    case 'Art':
      return Art;
    case 'Audio':
      return Audio;
    case 'Ball':
      return Ball;
    case 'BankNote':
      return BankNote;
    case 'BankNotes':
      return BankNotes;
    case 'Bell':
      return Bell;
    case 'Bike':
      return Bike;
    case 'Blind':
      return Blind;
    case 'Boat':
      return Boat;
    case 'Book':
      return Book;
    case 'Bookmark':
      return Bookmark;
    case 'BookmarkVariation':
      return BookmarkVariation;
    case 'Box':
      return Box;
    case 'Burger':
      return Burger;
    case 'Bus':
      return Bus;
    case 'Calculator':
      return Calculator;
    case 'Calendar':
      return Calendar;
    case 'CalendarDays':
      return CalendarDays;
    case 'Camera':
      return Camera;
    case 'Car':
      return Car;
    case 'Card':
      return Card;
    case 'CardBundle':
      return CardBundle;
    case 'CardMachine':
      return CardMachine;
    case 'Cars':
      return Cars;
    case 'ChartDiagram':
      return ChartDiagram;
    case 'ChartEuro':
      return ChartEuro;
    case 'Chat':
      return Chat;
    case 'Check':
      return Check;
    case 'CheckCircleInverted':
      return CheckCircleInverted;
    case 'CheckCircleOutline':
      return CheckCircleOutline;
    case 'CheckShieldOutline':
      return CheckShieldOutline;
    case 'Checked':
      return Checked;
    case 'ChevronDown':
      return ChevronDown;
    case 'ChevronDownSmall':
      return ChevronDownSmall;
    case 'ChevronLeft':
      return ChevronLeft;
    case 'ChevronLeftRight':
      return ChevronLeftRight;
    case 'ChevronLeftSmall':
      return ChevronLeftSmall;
    case 'ChevronRight':
      return ChevronRight;
    case 'ChevronRightSmall':
      return ChevronRightSmall;
    case 'ChevronUp':
      return ChevronUp;
    case 'ChevronUpSmall':
      return ChevronUpSmall;
    case 'CircleBack':
      return CircleBack;
    case 'Clock':
      return Clock;
    case 'Close':
      return Close;
    case 'CloseCircleInverted':
      return CloseCircleInverted;
    case 'CloseCircleOutline':
      return CloseCircleOutline;
    case 'Cloud':
      return Cloud;
    case 'CoffeeBreak':
      return CoffeeBreak;
    case 'CoinCrossed':
      return CoinCrossed;
    case 'Coins':
      return Coins;
    case 'Compass':
      return Compass;
    case 'Connect':
      return Connect;
    case 'Contract':
      return Contract;
    case 'Contrast':
      return Contrast;
    case 'Copy':
      return Copy;
    case 'Cursor':
      return Cursor;
    case 'Cutlery':
      return Cutlery;
    case 'Deaf':
      return Deaf;
    case 'Deka':
      return Deka;
    case 'Depot':
      return Depot;
    case 'Desktop':
      return Desktop;
    case 'Directions':
      return Directions;
    case 'Dot':
      return Dot;
    case 'DotsHorizontal':
      return DotsHorizontal;
    case 'DotsVertical':
      return DotsVertical;
    case 'DoubleCheck':
      return DoubleCheck;
    case 'Download':
      return Download;
    case 'DownloadBox':
      return DownloadBox;
    case 'Duration':
      return Duration;
    case 'EasyLanguage':
      return EasyLanguage;
    case 'Education':
      return Education;
    case 'EmptyTrash':
      return EmptyTrash;
    case 'Euro':
      return Euro;
    case 'EuroWallet':
      return EuroWallet;
    case 'ExternalLink':
      return ExternalLink;
    case 'Eye':
      return Eye;
    case 'Facebook':
      return Facebook;
    case 'File':
      return File;
    case 'FileDiagram':
      return FileDiagram;
    case 'FileInfo':
      return FileInfo;
    case 'FilePlayButton':
      return FilePlayButton;
    case 'FileTable':
      return FileTable;
    case 'FileUndefined':
      return FileUndefined;
    case 'Filter':
      return Filter;
    case 'FilterActivated':
      return FilterActivated;
    case 'Flag':
      return Flag;
    case 'Folder':
      return Folder;
    case 'FolderAdd':
      return FolderAdd;
    case 'Frequency':
      return Frequency;
    case 'Gass':
      return Gass;
    case 'GiropayPaycheck':
      return GiropayPaycheck;
    case 'Glasses':
      return Glasses;
    case 'Globe':
      return Globe;
    case 'Gold':
      return Gold;
    case 'GooglePodcast':
      return GooglePodcast;
    case 'Growth':
      return Growth;
    case 'Guitar':
      return Guitar;
    case 'HandInHand':
      return HandInHand;
    case 'HandShake':
      return HandShake;
    case 'HeartInverted':
      return HeartInverted;
    case 'HeartLine':
      return HeartLine;
    case 'HeartOutlined':
      return HeartOutlined;
    case 'Helmet':
      return Helmet;
    case 'Hide':
      return Hide;
    case 'Home':
      return Home;
    case 'HomeInverted':
      return HomeInverted;
    case 'HourGlass':
      return HourGlass;
    case 'HourGlassUp':
      return HourGlassUp;
    case 'IdCard':
      return IdCard;
    case 'ImpulsLogo':
      return ImpulsLogo;
    case 'Industry':
      return Industry;
    case 'InfoCircleInvert':
      return InfoCircleInvert;
    case 'InfoCircleOutline':
      return InfoCircleOutline;
    case 'Instagram':
      return Instagram;
    case 'Key':
      return Key;
    case 'Laptop':
      return Laptop;
    case 'Letter':
      return Letter;
    case 'Like':
      return Like;
    case 'LineHeight':
      return LineHeight;
    case 'LinkedIn':
      return LinkedIn;
    case 'Living':
      return Living;
    case 'Location':
      return Location;
    case 'LocationPins':
      return LocationPins;
    case 'Lock':
      return Lock;
    case 'LockEuro':
      return LockEuro;
    case 'LockNegative':
      return LockNegative;
    case 'Mail':
      return Mail;
    case 'Mask':
      return Mask;
    case 'Minus':
      return Minus;
    case 'Mobile':
      return Mobile;
    case 'MobilePay':
      return MobilePay;
    case 'Mobility':
      return Mobility;
    case 'MoneyHand':
      return MoneyHand;
    case 'Note':
      return Note;
    case 'Options':
      return Options;
    case 'PalmTree':
      return PalmTree;
    case 'PaperAirplane':
      return PaperAirplane;
    case 'PaperClip':
      return PaperClip;
    case 'Paragraph':
      return Paragraph;
    case 'ParkingSpace':
      return ParkingSpace;
    case 'Partner':
      return Partner;
    case 'Pause':
      return Pause;
    case 'PayDirekt':
      return PayDirekt;
    case 'Paypal':
      return Paypal;
    case 'Pdf':
      return Pdf;
    case 'Pen':
      return Pen;
    case 'PercentCircleOutline':
      return PercentCircleOutline;
    case 'Percentage':
      return Percentage;
    case 'PersonFemale':
      return PersonFemale;
    case 'PersonMale':
      return PersonMale;
    case 'PersonPlus':
      return PersonPlus;
    case 'Pet':
      return Pet;
    case 'PiggyLeft':
      return PiggyLeft;
    case 'PiggyRight':
      return PiggyRight;
    case 'Pin':
      return Pin;
    case 'PinCode':
      return PinCode;
    case 'PlayButton':
      return PlayButton;
    case 'PlusMinus':
      return PlusMinus;
    case 'Puzzle':
      return Puzzle;
    case 'Pyramid':
      return Pyramid;
    case 'QuestionCircleInvert':
      return QuestionCircleInvert;
    case 'QuestionCircleOutline':
      return QuestionCircleOutline;
    case 'Reload':
      return Reload;
    case 'ReloadLeft':
      return ReloadLeft;
    case 'ReloadRight':
      return ReloadRight;
    case 'RemoveCircleOutline':
      return RemoveCircleOutline;
    case 'RollerBlades':
      return RollerBlades;
    case 'Rooms':
      return Rooms;
    case 'RudiLogo':
      return RudiLogo;
    case 'RoundedCoins':
      return RoundedCoins;
    case 'SackBarrow':
      return SackBarrow;
    case 'Search':
      return Search;
    case 'SearchReflection':
      return SearchReflection;
    case 'SendEuro':
      return SendEuro;
    case 'Setting':
      return Setting;
    case 'Settings':
      return Settings;
    case 'ShareSocialMedia':
      return ShareSocialMedia;
    case 'ShieldOutline':
      return ShieldOutline;
    case 'SparkasseLogo':
      return SparkasseLogo;
    case 'Speaker':
      return Speaker;
    case 'SpeechBubbleInverted':
      return SpeechBubbleInverted;
    case 'SpeechBubbles':
      return SpeechBubbles;
    case 'Speedo':
      return Speedo;
    case 'Spotify':
      return Spotify;
    case 'Star':
      return Star;
    case 'Stitcher':
      return Stitcher;
    case 'Stop':
      return Stop;
    case 'Suitcase':
      return Suitcase;
    case 'Sun':
      return Sun;
    case 'TShirt':
      return TShirt;
    case 'Tablet':
      return Tablet;
    case 'Target':
      return Target;
    case 'Telephone':
      return Telephone;
    case 'TelephoneCircleOutline':
      return TelephoneCircleOutline;
    case 'TextAlignment':
      return TextAlignment;
    case 'TextSize':
      return TextSize;
    case 'Tiktok':
      return Tiktok;
    case 'Trash':
      return Trash;
    case 'Travel':
      return Travel;
    case 'Tree':
      return Tree;
    case 'Truck':
      return Truck;
    case 'TuneIn':
      return TuneIn;
    case 'TurnOff':
      return TurnOff;
    case 'Twitter':
      return Twitter;
    case 'Umbrella':
      return Umbrella;
    case 'Unequal':
      return Unequal;
    case 'Unlocked':
      return Unlocked;
    case 'UnreadMailInverted':
      return UnreadMailInverted;
    case 'Upload':
      return Upload;
    case 'UploadBox':
      return UploadBox;
    case 'Volume':
      return Volume;
    case 'Wallet':
      return Wallet;
    case 'Watch':
      return Watch;
    case 'WhatsApp':
      return WhatsApp;
    case 'Wheelchair':
      return Wheelchair;
    case 'Wikipedia':
      return Wikipedia;
    case 'X':
      return X;
    case 'Xing':
      return Xing;
    case 'Youtube':
      return Youtube;
    default:
      return CheckCircleOutline;
  }
};
